// Единый предикат «на этом экране показывается лендинг (WelcomePage)».
//
// Один и тот же вопрос решают три места, и раньше условие дублировалось:
//   - HomeGate (Content.tsx) — что рендерить на "/": лендинг или редирект;
//   - showSidebar (App.tsx) — сайдбар скрыт, пока виден лендинг;
//   - contentNoSidebar (Content.tsx) — убрать 280px-зазор сайдбара под лендинг.
// Чтобы логика не разъезжалась (баг: залогиненному на `/?welcome=1` показывался
// сайдбар), держим её здесь одним предикатом.
/**
 * Превью-калитка для QA/демо: `/?welcome=1` всегда показывает лендинг, минуя
 * AB-гейт (не выбивает группу, на метрики не влияет).
 */
export const isWelcomePreviewOverride = (search) => new URLSearchParams(search).get("welcome") === "1";
/**
 * Активен ли лендинг на текущем экране. Только на "/", и либо превью-калитка
 * `?welcome=1`, либо свежесозданный гость в welcome-варианте AB-гейта. Для любого
 * возвратного посетителя/аккаунта (кроме превью) — false: там `/` редиректит на
 * /generate-song, и сайдбар/паддинг остаются штатными.
 */
export const isLandingActive = ({ pathname, search, isFreshGuestSession, welcomeVariant, }) => pathname === "/" &&
    (isWelcomePreviewOverride(search) ||
        (isFreshGuestSession && welcomeVariant === "welcome"));
